// Collegamento con il servizio di accesso sicuro (worker Cloudflare).
// Le password non vengono più confrontate nel browser: le verifica il server,
// che risponde con un token per entrare in Firebase Authentication.
import { signInWithCustomToken, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

export const URL_SERVIZIO_ACADEMY = 'https://academy-of-arts-push.academy-of-arts-push-11f97924.workers.dev';

export class ErroreServizio extends Error {
  constructor(messaggio, codice, stato) {
    super(messaggio);
    this.codice = codice;
    this.stato = stato;
  }
}

// Intestazioni con il token Firebase dell'utente collegato (se presente).
export async function intestazioniAutenticate(altre = {}) {
  const utente = auth.currentUser;
  if (!utente) return { ...altre };
  return { ...altre, Authorization: `Bearer ${await utente.getIdToken()}` };
}

async function chiama(percorso, corpo, { autenticato = false } = {}) {
  let risposta;
  try {
    const intestazioni = { 'Content-Type': 'application/json' };
    risposta = await fetch(`${URL_SERVIZIO_ACADEMY}${percorso}`, {
      method: 'POST',
      headers: autenticato ? await intestazioniAutenticate(intestazioni) : intestazioni,
      body: JSON.stringify(corpo || {})
    });
  } catch {
    throw new ErroreServizio('📶 Connessione non disponibile. Controlla Internet e riprova.', 'rete', 0);
  }
  const dati = await risposta.json().catch(() => ({}));
  if (!risposta.ok) throw new ErroreServizio(dati.errore || 'Servizio momentaneamente non disponibile. Riprova tra poco.', dati.codice || 'errore', risposta.status);
  return dati;
}

// ---------- Staff ----------
export async function caricaProfiliStaff() {
  return chiama('/accesso/profili-staff', {});
}

export async function accediStaff({ id, username, password }) {
  const { token, utente } = await chiama('/accesso/staff', { id, username, password });
  await signInWithCustomToken(auth, token);
  return utente;
}

export async function impostaPasswordStaff(id, password) {
  return chiama('/accesso/password-staff', { id, password }, { autenticato: true });
}

// ---------- Allievi ----------
export async function accediAllievo(codiceFiscale, password) {
  const { token, allievoId } = await chiama('/accesso/allievo', { codiceFiscale, password });
  await signInWithCustomToken(auth, token);
  const scheda = await getDoc(doc(db, 'allievi', allievoId));
  if (!scheda.exists()) throw new ErroreServizio('Scheda allievo non trovata. Contatta la segreteria.', 'cf_non_trovato', 404);
  const { passwordApp, ...dati } = scheda.data();
  return { id: scheda.id, ...dati };
}

// Passaggio dell'accesso dalla vecchia icona (browser) all'app Android, senza ridigitare i dati.
export async function creaCodiceAccessoApp() {
  const { codice } = await chiama('/accesso/codice-app', {}, { autenticato: true });
  return codice;
}

export async function accediAllievoConCodiceApp(codice) {
  const { token, allievoId } = await chiama('/accesso/con-codice-app', { codice });
  await signInWithCustomToken(auth, token);
  const scheda = await getDoc(doc(db, 'allievi', allievoId));
  if (!scheda.exists()) throw new ErroreServizio('Scheda allievo non trovata. Contatta la segreteria.', 'cf_non_trovato', 404);
  const { passwordApp, ...dati } = scheda.data();
  return { id: scheda.id, ...dati };
}

export function allievoCollegatoNelBrowser() {
  return Boolean(auth.currentUser?.uid?.startsWith('allievo_'));
}

// Controlla che la sessione Firebase corrisponda a chi risulta collegato nell'app.
export function sessioneFirebaseValida(utenteFirebase, { staffId, allievoId, admin = false } = {}) {
  if (!utenteFirebase) return false;
  if (allievoId) return utenteFirebase.uid === `allievo_${allievoId}`;
  if (admin && utenteFirebase.email && utenteFirebase.providerData?.some(p => p.providerId === 'password')) return true;
  if (staffId) return utenteFirebase.uid === `staff_${staffId}`;
  return false;
}

export async function esciDaFirebase() {
  try { await signOut(auth); } catch (errore) { console.warn('Uscita da Firebase non riuscita:', errore); }
}
